// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__-YhsC","shadow":"Banner_shadow__YyYh8","video":"Banner_video__T8a5h"};